import { render, staticRenderFns } from "./StockSlipInvoice.vue?vue&type=template&id=37c5acca&scoped=true"
import script from "./StockSlipInvoice.vue?vue&type=script&lang=js"
export * from "./StockSlipInvoice.vue?vue&type=script&lang=js"
import style0 from "./StockSlipInvoice.vue?vue&type=style&index=0&id=37c5acca&prod&scoped=true&lang=css"
import style1 from "./StockSlipInvoice.vue?vue&type=style&index=1&id=37c5acca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c5acca",
  null
  
)

export default component.exports